<template>
  <div>
    <svg width="20px" height="18px"
         viewBox="0 0 24 25"
         version="1.1"
    >
      <g
        id="icon-calendar"
        stroke="none"
        stroke-width="1"
        fill="currentColor"
        fill-rule="evenodd"
      >
        <path
          id="icon-calendar"
          d="M20.73,22.52 L20.73,8.75 L3.27,8.75 L3.27,22.52 L20.73,22.52 Z M20.73,2.48 C21.4100034,2.48 21.9999975,2.7299975 22.5,3.23 C23.0000025,3.7300025 23.25,4.3199966 23.25,5 L23.25,22.52 C23.25,23.2000034 23.0000025,23.7799976 22.5,24.26 C21.9999975,24.7400024 21.4100034,24.98 20.73,24.98 L3.27,24.98 C2.5699965,24.98 1.97500245,24.7400024 1.485,24.26 C0.99499755,23.7799976 0.75,23.2000034 0.75,22.52 L0.75,5 C0.75,4.3199966 0.99499755,3.7300025 1.485,3.23 C1.97500245,2.7299975 2.5699965,2.48 3.27,2.48 L4.5,2.48 L4.5,0.02 L7.02,0.02 L7.02,2.48 L16.98,2.48 L16.98,0.02 L19.5,0.02 L19.5,2.48 L20.73,2.48 Z M18.27,11.27 L18.27,13.73 L15.75,13.73 L15.75,11.27 L18.27,11.27 Z M13.23,11.27 L13.23,13.73 L10.77,13.73 L10.77,11.27 L13.23,11.27 Z M8.25,11.27 L8.25,13.73 L5.73,13.73 L5.73,11.27 L8.25,11.27 Z"
          fill="currentColor"
        ></path>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
    name: 'Calendar',
}
</script>
<style scoped>
svg {
  fill: currentColor;
}
</style>
